module.exports = __webpack_public_path__ + "media/src/images/abouts/items/stores/hanataba-3783d60a9502842fa507e1a6622f609a.jpg";